/** @jsxImportSource theme-ui */

type Props = {
  fill?: string;
};

const IconTypeScript = ({ fill = "black", ...props }: Props) => (
  <svg viewBox="0 0 32 32" {...props}>
    <path fill="#007acc" d="M2 16L2 30 16 30 30 30 30 16 30 2 16 2 2 2 2 16z" />
    <path
      d="M24.564 14.884a3.485 3.485 0 011.751 1.009 4.611 4.611 0 01.671.9c.009.036-1.209.853-1.947 1.311-.027.018-.133-.1-.253-.276a1.587 1.587 0 00-1.316-.791c-.849-.058-1.4.387-1.391 1.129a1.027 1.027 0 00.12.524c.187.387.533.618 1.622 1.089 2 .862 2.862 1.431 3.4 2.24a4.063 4.063 0 01.324 3.413 3.753 3.753 0 01-3.1 2.218 8.584 8.584 0 01-2.133-.022 5.145 5.145 0 01-2.849-1.484 4.947 4.947 0 01-.729-1.08 2.092 2.092 0 01.258-.164c.124-.071.6-.342 1.04-.6l.8-.467.168.247a3.759 3.759 0 001.067 1.02 2.6 2.6 0 002.724-.138 1.217 1.217 0 00.156-1.551c-.218-.311-.662-.573-1.924-1.12a6.93 6.93 0 01-2.636-1.622 3.692 3.692 0 01-.769-1.4 5.606 5.606 0 01-.049-1.787 3.413 3.413 0 012.871-2.658 7.092 7.092 0 012.124.06zm-6.573 1.169L18 17.2h-3.644v10.356h-2.578V17.2H8.133v-1.124a11.018 11.018 0 01.031-1.156c.013-.018 2.231-.027 4.92-.022l4.893.013z"
      fill="#fff"
    />
  </svg>
);

export default IconTypeScript;
